import { render, staticRenderFns } from "./SoftphoneAudioDevices.vue?vue&type=template&id=50a50cc2&scoped=true"
import script from "./SoftphoneAudioDevices.vue?vue&type=script&lang=js"
export * from "./SoftphoneAudioDevices.vue?vue&type=script&lang=js"
import style0 from "./SoftphoneAudioDevices.vue?vue&type=style&index=0&id=50a50cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a50cc2",
  null
  
)

export default component.exports